<template>
    <div
        class="add-container"
    >
        <div
            v-for="(item,index) in itemList"
            :key="item._uuid_"
            class="add-item"
        >
            <slot
                :item="item"
                :$index="index"
            ></slot>
            <mc-button
                v-if="showDeleteCondition(item, index, itemList)"
                class="delete-btn"
                type="warning"
                size="mini"
                :disabled="disabled"
                @click="deleteItem(index)"
            >
                删除
            </mc-button>
        </div>
        <mc-button
            v-if="showAddCondition(itemList)"
            type="primary"
            size="mini"
            :disabled="innerDisabled || disabled"
            @click="addItem"
        >
            增加{{ title }}
        </mc-button>
    </div>
</template>

<script>
import { getAliasUuid } from 'tools/utils';

export default {
    name: 'AddContainer',
    components: {
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        initItem: { // 返回一个 item 的结构
            type: Function,
            required: true,
            default: () => {
                throw new Error('未提供 initItem 方法，无法初始化');
            },
        },
        itemList: {
            type: Array,
            default: () => [],
        },
        // 最大个数 默认10个
        maxSize: {
            type: Number,
            default: 10,
        },
        showDeleteCondition: {
            type: Function,
            default: () => true,
        },
        showAddCondition: {
            type: Function,
            default: () => true,
        },
        beforeAdd: {
            type: Function,
            default: () => true,
        },
        addBtnDisabled: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        innerDisabled() {
            if (this.itemList.length >= this.maxSize) return true;
            return false;
        },
    },
    watch: {
        itemList(newVal) {
            if (newVal) {
                this.itemList.forEach((item) => {
                    if (!item._uuid_) item._uuid_ = getAliasUuid();
                });
            }
        },
    },
    created() {
        if (this.itemList.length) {
            this.itemList.forEach((item) => {
                item._uuid_ = getAliasUuid();
            });
        }
    },
    mounted() {
    },
    methods: {
        addItem() {
            // todo支持promise
            if (!this.beforeAdd(this.itemList)) return;
            this.itemList.push(Object.assign(this.initItem(), { _uuid_: getAliasUuid() }));
            this.$emit('change', 'add', this.itemList);
        },

        deleteItem(index) {
            this.itemList.splice(index, 1);
            this.$emit('change', 'delete', this.itemList);
        },
        getData() {
            return this.itemList;
        },
    },
};
</script>

<style scoped>
.add-item{
    margin-top: 5px;
    position: relative;
}
.delete-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
}
</style>
